<div class="form">
    <div class="body">
        <div class="mb-25">            
            <div>
                <select [class]="getClassesForInput('utilityId', true, (account.utility==null)?null:account.utility.name)" [disabled]="disableSelectorOfUtilityData" name="utilityId" [(ngModel)]="utilityId" (change)="resetError('utilityId'); reloadSelects();">
                    @if (utilityId==0) {
                    <option [selected]="true" [disabled]="true">Utility</option>
                    }
                    @for (utility of utilities; track utility) {
                    <option [ngValue]="utility.id">{{utility.name}}</option>
                    }
                </select>
                @if (getVisibilityForLabel((account.utility==null)?null:account.utility.name) || utilityId==-1) {
                <div class="placeholder">
                    Utility
                </div>
                }
                @if (utilityId!=-1) {
                <div>
                    @if (account.utility!=null && account.utility.id!=generalService.BETA_UTILITY_ID) {
                    <div>
                        Unfortunately your account involves an utility distribution company that falls outside of our program. We will save the Account and notify you when kilowant becomes active in your location.
                    </div>
                    }
                    <select [class]="getClassesForInput('loadZoneId', true, (account.loadZone==null)?null:account.loadZone.id+'')"
                            [disabled]="disableSelectorOfUtilityData"
                            [compareWith]="compareFn"
                            name="loadZoneId"
                            (change)="resetError('loadZoneId');"
                            [(ngModel)]="account.loadZone">
                        @if (account.loadZone==null) {
                        <option [ngValue]="null" [disabled]="true">Load Zone</option>
                        }
                        @for (loadZone of loadZones; track loadZone) {
                        <option [ngValue]="loadZone">{{loadZone.name}}</option>
                        }
                    </select>
                    @if (getVisibilityForLabel((account.loadZone==null)?null:account.loadZone.id+'')) {
                    <div class="placeholder">Load Zone</div>
                    }
                    <select [class]="getClassesForInput('rateClassId', true, (account.rateClass==null)?null:account.rateClass.name)"
                            [compareWith]="compareFn"
                            [disabled]="disableSelectorOfUtilityData"
                            name="rateClassId"
                            (change)="resetError('rateClassId');"
                            [(ngModel)]="account.rateClass">
                        @if (account.rateClass==null) {
                        <option [ngValue]="null" [disabled]="true">Rate Class</option>
                        }
                        @for (rateClass of rateClasses; track rateClass) {
                        <option [ngValue]="rateClass">{{rateClass.name}}</option>
                        }
                    </select>
                    @if (getVisibilityForLabel((account.rateClass==null)?null:account.rateClass.name)) {
                    <div class="placeholder">Rate Class</div>
                    }
                </div>
                }
            </div>            
            @if (account.utility) {
            <div>
                <input type="text"
                       #serviceName
                       name="serviceName"
                       [class]="getClassesForInput('serviceName', true, account.serviceName)"
                       (input)="resetError('serviceName')"
                       autocomplete="off"
                       placeholder="Customer Name"
                       [(ngModel)]="account.serviceName"
                       [minlength]="validationService.getMinLength('Account', 'serviceName')"
                       [maxlength]="validationService.getMaxLength('Account', 'serviceName')" />
                @if (getVisibilityForLabel(account.serviceName)) {
                <div class="placeholder">Customer Name</div>
                }
                <div class="right-margin-icon info-icon after-placeholder cursor-pointer" (click)="openExampleDialog(false)"></div>
                @if (!byAdvisor) {
                <select class="placeholder" [(ngModel)]="clientType" (change)="switchClientType()">
                    <option [selected]="(clientType=='Residential')" value="Residential">Residential</option>
                    <option [selected]="(clientType=='Commercial')" value="Commercial">Commercial</option>
                </select>
                <div class="placeholder">Customer Class</div>
                }
                <input type="text"
                       name="address"
                       [class]="getClassesForInput('addressLine1', true, account.addressLine1)"
                       (input)="resetError('addressLine1')"
                       placeholder="Service Address"
                       [(ngModel)]="account.addressLine1"
                       [minlength]="validationService.getMinLength('Account', 'address')"
                       [maxlength]="validationService.getMaxLength('Account', 'address')" />
                @if (getVisibilityForLabel(account.addressLine1)) {
                <div class="placeholder">Service Address</div>
                }
                <input type="text"
                       name="address"
                       [class]="getClassesForInput('addressLine2', true, account.addressLine2)"
                       (input)="resetError('addressLine2')"
                       placeholder="Address Line 2"
                       [(ngModel)]="account.addressLine2"
                       [minlength]="0"
                       [maxlength]="validationService.getMaxLength('Account', 'address')" />
                @if (getVisibilityForLabel(account.addressLine2)) {
                <div class="placeholder">Address Line 2</div>
                }
                <div class="cols">
                    @if (cityStateShow()) {
                    <div class="col auto">
                        <input type="text" name="City" [value]="account.city" [disabled]="true" [class]="getClassesForInput('city', true, 'city')" />
                        <div class="placeholder">City</div>
                    </div>
                    }
                    @if (cityStateShow()) {
                    <div class="col">
                        <input type="text" name="State" [value]="getStateName(account.state)" [disabled]="true" style="width: 60px" [class]="getClassesForInput('stateId', true, 'state')" />
                        <div class="placeholder">State</div>
                    </div>
                    }
                    <div class="col" [class]="(cityStateShow())?'':'auto'">
                        <input type="text"
                               name="address"
                               [class]="getClassesForInput('zip', true, account.zip)"
                               [style]="(cityStateShow())?'width: 70px;':''"
                               (input)="zipChanged()"
                               placeholder="Zip"
                               [(ngModel)]="account.zip"
                               [minlength]="validationService.getMinLength('Account', 'zip')"
                               [maxlength]="validationService.getMaxLength('Account', 'zip')" />
                        @if (getVisibilityForLabel(account.zip)) {
                        <div class="placeholder">Zip</div>
                        }
                    </div>
                </div>
                <input type="text"
                       name="accountNumber"
                       (input)="resetError('accountNumber')"
                       placeholder="Account number"
                       [formControl]="currentAccountNumber"
                       [dropSpecialCharacters]="false"
                       [mask]="(account.utility.accountTemplate!=null)?account.utility.accountTemplate:'0000000000'"
                       (focus)="focusField('accountNumber')"
                       (focusout)="focusOutField('accountNumber');"
                       [showMaskTyped]="(focusedField()=='accountNumber') || ((currentAccountNumber.value!=null) && (currentAccountNumber.value!=''))"
                       [disabled]="skipAccountNumberCheck"
                       [class]="getClassesForInput('accountNumber', true, ((currentAccountNumber.value==null)?'':currentAccountNumber.value?.trim())) + ((focusedField()=='accountNumber') || ((currentAccountNumber.value!=null) && (currentAccountNumber.value!=''))?' ls-5':'')" />
                @if (getVisibilityForLabel(((currentAccountNumber.value==null)?'':currentAccountNumber.value?.trim())+((focusedField()=='accountNumber')?'account':''))) {
                <div class="placeholder">Account number</div>
                }
                <input type="text"
                       name="keyName"
                       [class]="getClassesForInput('keyName', true, account.keyName)"
                       (input)="resetError('keyName')"
                       placeholder="Shopping ID"
                       [(ngModel)]="account.keyName"
                       [minlength]="validationService.getMinLength('Account', 'keyName')"
                       [maxlength]="validationService.getMaxLength('Account', 'keyName')" />
                @if (getVisibilityForLabel(account.keyName)) {
                <div class="placeholder">Shopping ID</div>
                }

                @if (this.clientType == "Commercial") {
                @if(!newCompanyRegistration()) {
                <div>
                    @if (byAdvisor) {
                    <input type="text" name="companyName" [disabled]="true" [class]="getClassesForInput('companyName', true, account.company!.name)" placeholder="Company Name" (input)="resetError('companyName')" [(ngModel)]="account.company!.name" />
                    <div class="placeholder">Company Name</div>
                    }
                    @if (!byAdvisor) {
                    <select name="company" [class]="getClassesForInput('companyName', true, null)+' placeholder'" [compareWith]="compareFn" [(ngModel)]="account.company" (change)="resetError('companyName'); selectExistingCompany()">
                        <option [ngValue]="null" [disabled]="true">Select Company</option>
                        @for (company of userCompanies; track company) {
                        <option [ngValue]="company">{{company.name}}</option>
                        }
                    </select>
                    <div class="placeholder" style="text-align: right; padding-right: 28px;"><a (click)="setNewCompany()">Add New Company</a></div>
                    }
                </div>
                }
                @if(newCompanyRegistration()) {
                <div>
                    <input type="text" name="companyName" [class]="getClassesForInput('companyName', true, account.company!.name)" placeholder="Company Name" (input)="resetError('companyName')" [(ngModel)]="account.company!.name" />
                    @if (getVisibilityForLabel(account.company!.name)) {
                    <div class="placeholder">Company Name</div>
                    }
                    @if (this.userCompanies!=null && this.userCompanies.length>0) {
                    <div style="text-align: right; font-size: 13px; margin-top: -5px;"><a (click)="switchToCompanySelect();">Select from existing companies</a></div>
                    }
                </div>
                }
                <div>
                    <div class="mb-10 mt-10">
                        <label>
                            <input type="checkbox" name="taxExempt" (change)="taxExemptChanged()" [disabled]="!newCompanyRegistration() && !taxExemptAllowToAdd()" [(ngModel)]="taxExempt" /> Is your business
                            tax exempt?
                        </label>
                    </div>
                    @if (account.company!=null && taxExempt && account.company.taxExempt) {
                    <div>
                        <input type="text" name="FederalTaxID" class="w-100"
                               [class]="getClassesForInput('FederalTaxID', true, account.company.federalTaxID)" value=""
                               (input)="resetError('FederalTaxID')" [(ngModel)]="account.company.federalTaxID"
                               [disabled]="!newCompanyRegistration() && !taxExemptAllowToAdd()"
                               placeholder="Federal Tax ID" />
                        @if (getVisibilityForLabel(account.company.federalTaxID)) {
                        <div class="placeholder">Federal Tax ID</div>
                        }
                        <div class="mt-20"> Please upload a photo or a copy of your tax exempt certificate.</div>
                        @if ((fileToUpload==null) && account.company.taxExemptCertificateDocument==null) {
                        <label class="formLabel"
                               [class]="(errorY().isWrong('fileToUpload'))?'error':''">
                            CHOOSE FILES
                            <span>no files selected</span>
                            <input type="file" name="taxExemptCertificateDocument" class="required" value=""
                                   placeholder="Tax Exempt Certificate Document" [disabled]="!newCompanyRegistration() && !taxExemptAllowToAdd()" (change)="handleFileInput($event)" />
                        </label>
                        }
                        @if (fileToUpload!=null || account.company.taxExemptCertificateDocument!=null) {
                        <div class="files-list">
                            <span>File selected</span>
                            <ul>
                                @if (account.company.taxExemptCertificateDocument!=null) {
                                <li>
                                    @if (newCompanyRegistration() || taxExemptAllowToAdd()) {
                                    <a (click)="deleteExistingFile(account.company.taxExemptCertificateDocument.key)"></a>
                                    }
                                    <div class="link" (click)="downloadFile(true, account.company.taxExemptCertificateDocument.key)">{{account.company.taxExemptCertificateDocument.value}}</div>
                                </li>
                                }
                                @if (fileToUpload!=null) {
                                <li>
                                    @if (newCompanyRegistration() || taxExemptAllowToAdd()) {
                                    <a (click)="deleteFile()"></a>
                                    }
                                    <div class="link" (click)="downloadFile(false, null)">{{fileToUpload.name}}</div>
                                </li>
                                }
                            </ul>
                        </div>
                        }
                    </div>
                    }
                </div>
                }
            </div>
            }
            @if (errorY().showError() && errorY().error!='accountissue') {
            <div class="error-block">{{errorY().error}}</div>
            }
            @if (errorY().showError() && errorY().error=='accountissue') {
            <div class="error-block">The account number you entered is already in use. Please verify the number and try again. If you believe that your account number has been used without your authorization, please <a (click)="reportAccountIssue()">click here</a> to report it to kilowant for investigation.</div>
            }
            @if (!errorY().showError() && warningCommercial) {
            <div class="warning-block">You are attempting to add a commercial utility account to a residential client.  In order to proceed, you will need to reclassify the client to commercial via Menu > Client.  Alternatively, you can create a new commercial client via Menu > Add.</div>
            }
        </div>
    </div>
    <div class="block-buttons full-width under-card">
        <button type="button" (click)="cancel()">Back</button>
        <button type="button" class="highlighted-button" (click)="nextStep();">Next</button>
    </div>
    <div>&nbsp;</div>
</div>
